import store from "store";

const blockedItemToast = {

    blockedItem: (message: string, message2: string, actionButton: any, buttonActionLabel?: string, buttonLabel?: string, additionalInformation?: JSX.Element | string) =>
    store.dispatch({
      type: "OPEN_BLOCKED_ITEM_TOAST", data:
        { additionalInformation, text: message, text2: message2, actionButton, buttonActionLabel, buttonLabel }
    }),  
}

export default blockedItemToast;